import React from 'react'
import styled from 'styled-components'
import imgixUrlOptimizerAuto from '../../utils/imgixUrlOptimizerAuto'
import ExamResultCouple from '../../assets/img/exam-result-couple.svg'
import { MainTitle } from '../Typography'

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 126px;

   @media (max-width: 1024px) {
    padding: 40px 20px;
   }
`

const Grid = styled.div`
    display: flex;
    flex-direction: row;
    text-align: left;
    gap: 32px;

    @media (max-width: 1024px) {
        display: flex;
        flex-direction: column-reverse;
    }

`

const TextWrapper = styled.div`
  color: ${props => props.theme.colors.gray66};

  @media (max-width: 1024px) {
    width: 100%;
  }
`

const Text = styled.div`
  font-size: 16px;
  line-height:  20.96px;
  color: ${props => props.theme.colors.gray66};
  margin-top: 20px;

  strong {
    font-weight: bold;
  }

  em {
    font-style: italic;
  }
`
const Image = styled.img`
  max-width: 400px;
  width: 373px;

  @media (max-width: 1024px) {
    width: 100%;   
  }
`

export default function ResultadoExameInfo() {
  return (
    <Wrapper>
      <Grid>
        <TextWrapper>
          <MainTitle>Resultados de exames – retirada do resultado por terceiros ou portador</MainTitle>
          <Text>
            É possível entregar os resultados de exames para <strong>terceiros ou portador a pedido do cliente sem o comprovante de resultados
            </strong> (Não se aplica para resultados dos exames de Teste de Paternidade/sigilosos), mas para isso <strong>
            é necessário a autorização de coordenação da unidade mediante a apresentação do documento original com foto do cliente (RG) </strong>
            e também do terceiro e/ou portador.
          </Text>
        </TextWrapper>
            <Image
            src={imgixUrlOptimizerAuto(ExamResultCouple)}
            alt="Ilustração de retirada de exames por terceiros"
            />
      </Grid>
    </Wrapper>
  )
}
